// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"vd__3KZaB","boldText":"vd__335rG","buttonWrapper":"vd__3dtCb","imageContainer":"vd__2Vf0C"};